var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"panel panel-default cart-form"},[_c('payment-marquee'),_c('div',{staticClass:"panel-body"},[_c('payment-type',{attrs:{"payments":_vm.payments}}),_c(_vm.renderMatchedComponent(),{tag:"component",attrs:{"is-rtype":_vm.isRtype}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }